//angular imports
import {
    WritableSignal,
    Signal,
    signal
} from "@angular/core";

//local imports
export interface IListItem {
    id: string;
    isChecked: WritableSignal<boolean>;
    name: Signal<string>;
    select: (isSelected: boolean) => void;
}

export class ListItem<TListItemType> implements IListItem {
    id: string;
    name: Signal<string>;
    isChecked: WritableSignal<boolean>;
    value: TListItemType;

    constructor(name: Signal<string>, id: string, value: TListItemType) {
        this.name = name;
        this.id = id;
        this.value = value;
        this.isChecked = signal<boolean>(false);
    }

    public select(val: boolean) {
        this.isChecked.set(val ? true : false);
    }
}

export class ListItemFactory
{
    public static create<TListItemType>(name: Signal<string>, id: string, value: TListItemType, isChecked: boolean = false) {

        let _this = new ListItem<TListItemType>(name, id, value);
        _this.isChecked = signal(isChecked);
        return _this;
    }
        
    public static create$<TListItemType>(name: Signal<string>, id: string, value: TListItemType, isChecked: WritableSignal<boolean> = signal(false)) {
        let _this = new ListItem<TListItemType>(name, id, value);
        _this.isChecked = isChecked;
        return _this;

    }
}